import * as apis from "./ServiceNow.api";
import * as queries from "./ServiceNow.queries";
import * as mutations from "./ServiceNow.mutations";

export default { ...apis, ...queries, ...mutations };
